<template>
  <div class="gd612-chart-wrap">
    <div class="gd612-chart__content scrollbar-none">
      <el-row v-for="(row, i) in rows" :gutter="30" :key="`row_${i}`">
        <el-col :xs="24" :lg="8" :span="24 / row.length" v-for="col in row" :key="col.sensorSeq">
          <chart ref="chart" :height="calcHeight(row.length)" :data="col"></chart>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Chart from './chart.vue';
import resize from '../utils/resize';
import { isMobile } from '@/utils/is';

export default {
  mixins: [resize],
  props: {
    datas: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Chart
  },
  computed: {
    rows() {
      const { datas } = this;
      const colNum = datas.length === 4 ? 2 : 3;
      const rows = [];
      let offset = 0;
      for (let i = 0, j = Math.ceil(datas.length / colNum); i < j; i++) {
        offset = i * colNum;
        rows.push(datas.slice(offset, offset + colNum));
      }
      return rows;
    },
    isMobile() {
      return isMobile();
    }
  },
  methods: {
    calcHeight() {
      const ol = this.datas.length;
      let height = (ol > 3 ? 1 : 2) * (this.unit - 20);
      return height > 260 ? height : 260;
    },
    setData(list, data) {
      this.$nextTick(() => {
        let temp = [];
        Array(list[0].sensors.length)
          .fill(0)
          .forEach((_, i) => {
            temp = list.map(e => ({
              beginTime: e.beginTime,
              ...(e.sensors[i] || {})
            }));
            this.$refs.chart[i].setDataList(temp, data.sensors[i]);
          });
      });
    }
  }
};
</script>

<style lang="scss">
.gd612-chart-wrap {
  $height: calc(100% - var(--status-bar-height) - var(--chart-wrap-mt) * 2 - var(--status-bar-mt));
  max-height: $height;
  height: $height;

  margin-top: var(--chart-wrap-mt);

  width: 100%;
  overflow: hidden;
  .gd612-chart__content {
    height: 100%;
    width: 100%;

    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
  }
}
</style>
